export const isVideoMimeType = (mimeType: string) => {
  const videoMimeTypeRegex = new RegExp(/video\/(mp4|mpeg)/);
  return videoMimeTypeRegex.test(mimeType);
};